import { DrawCabinetInsideGroupElement } from "$src/CGS/domain/dto/article/Cabinet/Inside/DrawCabinetInsideGroupElement";
import { EOrientation } from "$src/CGS/domain/dto/core/EOrientation";
import { InsideComputation } from "./InsideComputation";

export class InsideGroupComputation extends InsideComputation {
    context?: DrawCabinetInsideGroupElement;
    orientation: EOrientation = EOrientation.Vertical;
    elements: InsideComputation[] = [];

    constructor(orientation: EOrientation, elements: InsideComputation[], context?: DrawCabinetInsideGroupElement) {
        super();
        this.context = context;
        this.orientation = orientation;
        this.elements = elements ?? [];
    }

    get minWidth(): number {
        return this.orientation === EOrientation.Horizontal
            ? this.elements.reduce((acc, e) => acc + e.minWidth, 0)
            : Math.max(...this.elements.map(e => e.minWidth));
    }

    get minHeight(): number {
        return this.orientation === EOrientation.Horizontal
            ? Math.max(...this.elements.map(e => e.minHeight))
            : this.elements.reduce((acc, e) => acc + e.minHeight, 0);
    }

    get maxWidth(): number | null {
        if (this.elements.some(e => e.maxWidth === null)) {
            return null;
        }

        return this.orientation === EOrientation.Horizontal
            ? this.elements.reduce((acc, e) => acc + (e.maxWidth ?? 0), 0)
            : Math.max(...this.elements.map(e => e.maxWidth ?? 0));
    }

    get maxHeight(): number | null {
        if (this.elements.some(e => e.maxHeight === null)) {
            return null;
        }

        return this.orientation === EOrientation.Horizontal
            ? Math.max(...this.elements.map(e => e.maxHeight ?? 0))
            : this.elements.reduce((acc, e) => acc + (e.maxHeight ?? 0), 0);
    }

    get size(): number {
        return this.getMin(this.orientation);
    }
}
